import { Controller } from '@stimulus/core'
import IMask from 'imask'

export default class extends Controller {
  connect() {
    const masks = {
      'ru': '+{7}(000)000-00-00'
    }
    const lang = this.data.get('lang') || 'ru'

    // IMask(this.element, {
    //   mask: masks[lang],
    //   lazy: false,
    //   placeholderChar: '_'
    // })
  }
}
